import React from 'react';
import propTypes from 'prop-types';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import * as Next from "@alifd/next";
import Tinymce from '@alife/super-text';
import fetchJsonp from 'fetch-jsonp';
import * as tarot from '@alife/tarot';
import ctoken from '@alife/puck-csrftoken';
import * as redux from 'redux';
import * as dva from 'dva';
import dvaImmer from 'dva-immer';

import MessageTip from './components/message-tip';
import Image from './components/image';
import log from './common/log';
import puckParameter from './common/puck-middleware';
import errLog from './common/retcode-log';
import Utils from './common/utils';
import I18N from './common/i18n';
import * as webIO from './common/web-io';
import * as requestHelper from './common/request';
import CardMap from './common/card-map';

React.PropTypes = propTypes;
Next.Feedback = {
  toast: MessageTip
};
if(!window.IcbuIM){
  window.IcbuIM = {};
}
const IcbuIM = window.IcbuIM;
IcbuIM['prop-types'] = propTypes;
IcbuIM.classnames = classNames;
IcbuIM['fetch-jsonp'] = fetchJsonp;
IcbuIM.redux = redux;
IcbuIM['dva-immer'] = dvaImmer;
IcbuIM['@alife/bc-i18n'] = I18N;
IcbuIM.dva1 = dva;
IcbuIM.React16 = React;
IcbuIM.propTypes = propTypes;
IcbuIM.ReactDOM16 = ReactDOM;
IcbuIM.Next1 = Next;
IcbuIM.TinymceOnReact16 = Tinymce;
IcbuIM.TarotOnReact16 = tarot;

IcbuIM.lib = {};
IcbuIM.lib.MessageTip = MessageTip;
IcbuIM.lib.Image = Image;
IcbuIM.lib.log = log;
IcbuIM.lib.ctoken = ctoken;
IcbuIM.lib.puckParameter = puckParameter;
IcbuIM.lib.errLog = errLog;
IcbuIM.lib.Utils = Utils;
IcbuIM.lib.I18N = I18N;
IcbuIM.lib.webIO = webIO;
IcbuIM.lib.requestHelper = requestHelper;
IcbuIM.lib.CardMap = CardMap;

for (const key in IcbuIM) {
  exports[key] = IcbuIM[key];
}
console.log(IcbuIM,'====IcbuIM new')
export default IcbuIM;
